import RequestResetPasswordForm from "@/components/request-reset-password-form";
import MobileRequestResetPasswordForm from "@/components/mobile-request-reset-password-form";
import MobileLandscapeResetForm from "@/components/mobile-landscape-reset-form";
import { AuthCanvas } from "@/components/auth-canvas";

// 重設密碼请求页：沿用登录页 1920×1080 画布壳（AuthCanvas），右侧表单换成发送重设邮件表单。
function RequestResetPasswordPage() {
  return (
    <AuthCanvas
      renderDesktopForm={() => <RequestResetPasswordForm />}
      renderMobileForm={() => <MobileRequestResetPasswordForm />}
      renderLandscapeForm={({ colors }) => <MobileLandscapeResetForm colors={colors} />}
    />
  );
}

export default RequestResetPasswordPage;
